import { getMessage } from './MESSAGE';
import { useSignupData } from '../signup-data/useSignupData';
import { jsx as _jsx } from "react/jsx-runtime";
const getMessageComponent = messageKey => {
  const message = messageKey && getMessage(messageKey);
  return message && message.component;
};
const HighlightCaption = ({
  messageKey: landingPageMessageKey
}) => {
  const {
    dataKey,
    highlightMessageKeys,
    landingPageComponent
  } = getMessage(landingPageMessageKey);
  const {
    data: highlighted
  } = useSignupData(dataKey);
  const highlightMessageKey = highlightMessageKeys[highlighted];
  const HighlightComponent = getMessageComponent(highlightMessageKey);
  const MessageComponent = HighlightComponent || landingPageComponent;
  const messageKey = highlightMessageKey || landingPageMessageKey;

  // This arrangement forces React to fully unmount any nested AnimatedMessage
  // components immediately during component changes and prevents content
  // flickering before the reveal animation kicks in
  return [messageKey].map(renderingKey => /*#__PURE__*/_jsx(MessageComponent, {
    messageKey: messageKey
  }, renderingKey))[0];
};
export default HighlightCaption;